export default __webpack_public_path__ + "static/media/icon_password.9b9315f0.svg";